import { MAX_DELTA_REQUIRED_PRESSURE } from "@/libs/calculations/constants";
import {
  Severity,
  valuesExist,
  type ValidationRuleGenerator
} from "../scenarioValidator";
import { Flow_Model_Enum, Well_Test_Liquid_Input_Options_Enum } from "gql/api";
import { EquipmentCalculatorSectionKey } from "@/composables/scenarioCalculations/calculationTypes";

export const catastopheChecksNames = [
  "insufficient_pressure",
  "pi_ipr"
] as const;

/**
 * Catastrophe Check
 * If triggered, system won't be able to pump
 * the liquid  all the way up to the surface
 */

export const catastropheChecks: ValidationRuleGenerator = ({
  calcs,
  wellProperties,
  parameters
}) => {
  const producedDischargePressurePSI = calcs.pumpCalculations.aggregate.producedDischargePressurePSIA.value;
  const requiredDischargePressurePSI = calcs.pumpCalculations.aggregate.requiredDischargePressurePSIA.value;

  return [
    {
      name: "insufficient_pressure",
      message: "Insufficient Discharge Pressure",
      severity: Severity.catastrophe,
      isActive: valuesExist([
        producedDischargePressurePSI,
        requiredDischargePressurePSI
      ]),
      isInvalid:
        requiredDischargePressurePSI > producedDischargePressurePSI,
      rulePlacement: EquipmentCalculatorSectionKey.PUMP
    },
    // Vogel/IPR check
    {
      name: "pi_ipr",
      message: "It is recommended to use Straight Line IPR with PI/Water Cut",
      severity: Severity.warn,
      isActive:
        wellProperties.value?.well_test_liquid_input_type ===
        Well_Test_Liquid_Input_Options_Enum.ProductivityIndexWaterCut &&
        parameters.value?.flow_model !== Flow_Model_Enum.StraightLine,
      isInvalid:
        wellProperties.value?.well_test_liquid_input_type ===
        Well_Test_Liquid_Input_Options_Enum.ProductivityIndexWaterCut,
      rulePlacement: EquipmentCalculatorSectionKey.WELL_TEST
    }
  ];
};
